export const CHANGE_CONTENT = 'page.CHANGE_CONTENT';
export const CHANGE_CONTENTS = 'page.CHANGE_CONTENTS';
export const ADD_CONTENT_TO_PAGE = 'page.ADD_CONTENT_TO_PAGE';
export const DELETE_CONTENT_TO_PAGE = 'page.DELETE_CONTENT_TO_PAGE';
export const UPDATE_PAGE = 'page.UPDATE_PAGE';
export const CHANGE_PAGE = 'page.CHANGE_PAGE';
export const SAVE_PAGE= 'page.SAVE_PAGE';